import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockTitle: 'Мащабирай бизнеса си с наша помощ',
	blockDesc: 'Повече ресурси и експертна поддръжка, за да развиваш проектите си.',
	blockContent:
	  [
		  {
			  page: 'ManagedVPS',
			  title: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-common-managed-vps.php">Managed VPS</a>',
			  subTitle: 'Скалирай бизнеса си!',
			  desc: 'Осигури мощност и свобода за големите проекти.',
			  buttonText: 'Виж планове и цени',
			  buttonAction: 'RedirectTo',
			  buttonParams: [
				  getInitialMeta('siteURL') + 'web-hosting-common-managed-vps.php?tab=prices'
			  ],
			  ButtonModal: '',
			  buttonModalParams: {}
		  },
		  {
			  page: 'WPSupport',
			  title: '<a href="' + getInitialMeta('siteURL') + 'wp-support.php">Професионална поддръжка за WordPress</a>',
			  subTitle: 'Поддръжка 24/7',
			  desc: 'Екип от експерти се грижи сайтът ти да е бърз, защитен и винаги онлайн.',
			  buttonText: 'Виж планове и цени',
			  buttonAction: 'RedirectTo',
			  buttonParams: [
				  getInitialMeta('siteURL') + 'wp-support.php?tab=prices'
			  ],
			  ButtonModal: '',
			  buttonModalParams: {}
		  }
	  ]
};

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: 'Scale your business with our help',
	blockDesc: 'More resources and expert support to grow your projects.',
	blockContent:
	  [
		  {
			  page: 'ManagedVPS',
			  title: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-common-managed-vps.php">Managed VPS</a>',
			  subTitle: 'Scale your business!',
			  desc: 'Get the power and flexibility your large-scale projects need.',
			  buttonText: 'View Plans & Pricing',
			  buttonAction: 'RedirectTo',
			  buttonParams: [
				  getInitialMeta('siteURL') + 'web-hosting-common-managed-vps.php?tab=prices'
			  ],
			  ButtonModal: '',
			  buttonModalParams: {}
		  },
		  {
			  page: 'WPSupport',
			  title: '<a href="' + getInitialMeta('siteURL') + 'wp-support.php">Professional Support for WordPress</a>',
			  subTitle: '24/7 support',
			  desc: 'A team of experts ensures your website is fast, secure, and always online.',
			  buttonText: 'View Plans & Pricing',
			  buttonAction: 'RedirectTo',
			  buttonParams: [
				  getInitialMeta('siteURL') + 'wp-support.php?tab=prices'
			  ],
			  ButtonModal: '',
			  buttonModalParams: {}
		  }
	  ]
};

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];